const initHeroFullBanner = () => {
  const selector = '.hero-full-banner__swiper'
  const swiperEl = document.querySelector(selector)
  if (!swiperEl) return

  const autoScroll = swiperEl.getAttribute('data-auto-scroll') === 'true'
  const autoScrollSpeed = parseInt(swiperEl.getAttribute('data-auto-scroll-speed'), 10) * 1000

  const config = {
    slidesPerView: 1,
    pagination: {
      el: `${selector} .swiper-pagination`,
    },
    navigation: {
      nextEl: `${selector} .swiper-button-next`,
      prevEl: `${selector} .swiper-button-prev`,
    },
    autoplay: autoScroll ? {
      delay: autoScrollSpeed,
      disableOnInteraction: false,
    } : false,
  }

  let swiper = new Swiper(selector, config)

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(evt) {
      if (document.querySelector(selector)) {
        swiper = new Swiper(selector, config)
      }
    })

    document.addEventListener('shopify:section:unload', function() {
      if (swiper && swiper.destroy) swiper.destroy()
    })

    document.addEventListener('shopify:block:select', function(evt) {
      if (!evt.target.closest(selector)) return
      const index = Array.prototype.indexOf.call(evt.target.parentNode.children, evt.target)

      if (evt.detail.load) {
        swiper = new Swiper(selector, { initialSlide: index, ...config })
      } else {
        swiper.slideTo(index)
      }
    })
  }
}

initHeroFullBanner()
